import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  PageContainer,
  MainContent,
  Card,
  Heading1,
  Text,
  Button,
  FlexColumn,
  Spacer
} from "../../styles/StyledComponents";
import { ThemeColors, Spacing } from "../../styles/ThemeStyles";

interface PlaceholderScreenProps {
  title: string;
}

export const PlaceholderScreen: React.FC<PlaceholderScreenProps> = ({ title }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  return (
    <PageContainer isMenuCollapsed={true}>
      <MainContent>
        <FlexColumn style={{ alignItems: "center", justifyContent: "center", minHeight: "calc(100vh - 80px)" }}>
          <Card>
            <FlexColumn style={{ padding: Spacing.xl, alignItems: "center" }}>
              <Heading1>{title}</Heading1>
              <Spacer height={Spacing.md} />
              <Text size="lg">
                {t('common.comingSoon', { defaultValue: 'This feature is coming soon.' })}
              </Text>
              <Spacer height={Spacing.lg} />
              <Button onClick={() => navigate(-1)}>
                {t('common.back', { defaultValue: 'Go Back' })}
              </Button>
            </FlexColumn>
          </Card>
        </FlexColumn>
      </MainContent>
    </PageContainer>
  );
};

export const StoreResourceScreen = () => {
  const { t } = useTranslation();
  return <PlaceholderScreen title={t('navigation.storeResource', 'Store Resource')} />;
};

export const RequestContactScreen = () => {
  const { t } = useTranslation();
  return <PlaceholderScreen title={t('navigation.requestContact', 'Request Management Contact')} />;
};

export const OrderSuppliesScreen = () => {
  const { t } = useTranslation();
  return <PlaceholderScreen title={t('navigation.orderSupplies', 'Order Supplies')} />;
};

export const PayrollScreen = () => {
  const { t } = useTranslation();
  return <PlaceholderScreen title={t('navigation.payroll', 'Payroll')} />;
};

export const ContestEntryScreen = () => {
  const { t } = useTranslation();
  return <PlaceholderScreen title={t('navigation.contestEntry', 'Contest Entry')} />;
};
